<ng-container *ngIf="!(loginError$ | async) as res; else loginError">
  <section [@fadeIn] id="login" class="relative">
    <nobis-loading *ngIf="loading"></nobis-loading>
    <form [formGroup]="form" (ngSubmit)="handleSubmitLogin()">
      <mat-form-field color="accent" hideRequiredMarker appearance="outline">
        <button
          type="button"
          class="pointer-event-none"
          mat-icon-button
          matPrefix
          [attr.aria-label]="' Selecciona un tipo de documento'">
          <mat-icon svgIcon="dni"></mat-icon>
        </button>
        <mat-select formControlName="documentType" placeholder="Tipo de documento">
          <ng-container *ngIf="typesDocument$ | async as typesDocuments">
            <mat-option
              *ngFor="let item of typesDocuments"
              [value]="item.id"
              (click)="typeSelected(item.value)">
              {{ item.value }}
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-error *ngIf="form.controls['documentType'].hasError('required')">
          Seleccioná un tipo de documento
        </mat-error>
      </mat-form-field>

      <mat-form-field color="accent" hideRequiredMarker appearance="outline">
        <input
          matInput
          formControlName="document"
          type="number"
          pattern="[0-9]*"
          placeholder="Nº de {{ type }}" />
        <button
          type="button"
          class="pointer-event-none"
          mat-icon-button
          matPrefix
          [attr.aria-label]="'ingresa tu email'">
          <mat-icon svgIcon="123"></mat-icon>
        </button>
        <mat-error *ngIf="form.controls['document'].hasError('required')">
          Este campo es requerido
        </mat-error>
      </mat-form-field>

      <mat-form-field hideRequiredMarker color="accent" appearance="outline">
        <input
          placeholder="Contraseña"
          matInput
          formControlName="password"
          autocomplete="current-password"
          [type]="hide ? 'password' : 'text'" />
        <button
          type="button"
          mat-icon-button
          [color]="
            form.controls['password'].errors && form.controls['password'].touched
              ? 'warn'
              : 'accent'
          "
          matSuffix
          (click)="togglePasswordVisibility($event)"
          [attr.aria-label]="'Mostrar contraseña'"
          [attr.aria-pressed]="'Ocultar contrasena'">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <button type="button" mat-icon-button matPrefix class="pointer-event-none">
          <mat-icon svgIcon="icon-password"></mat-icon>
        </button>
        <mat-error *ngIf="form.controls['password'].hasError('required')">
          Este campo es requerido
        </mat-error>
      </mat-form-field>

      <mat-slide-toggle formControlName="rememberDocument"
        >Recordar tipo y número de documento</mat-slide-toggle
      >

      <div class="flex column">        
        <nobis-button [disabled]="form.invalid">INGRESAR</nobis-button>
      </div>
      
      <div class="action">
        <a [routerLink]="['recupera-tu-contraseña']">OLVIDÉ MI CONTRASEÑA</a>
        <a [routerLink]="['registrate']">REGISTRARME</a>
      </div>
    </form>

  </section>
</ng-container>

<ng-template #loginError let-error>
  <section id="login-error">
    <div class="wrapper">
      <img width="70" src="assets/svg/alert.svg" alt="" />
      <ng-container class="wrapper" *ngIf="loginError$ | async as error">
        <ng-container *ngIf="error.status !== 'with_ospm'; else ospm_template">          
          <h1 [ngClass]="{ break: error.status === 'Validation Error' }">{{ error.message }}</h1>
          <p *ngIf="error.status === 'coverage-inactive'">
            Por favor
            <strong>
              ponete en contacto con Lili, <br />
              nuestra asistenta virtual,</strong
            >haciendo
            <b (click)="redirectLogin()"
              ><a
                href="https://api.whatsapp.com/send?phone=543513893211"
                target="_blank"
                rel="noopener noreferrer"
                >clic acá
              </a>
            </b>
          </p>
          <p *ngIf="error.status === 'Validation Error'">
            <strong>Volvé a intentarlo</strong>, haciendo <b (click)="redirectLogin()">clic acá</b>
          </p>
  
          <p *ngIf="error.code === 500">
            <strong>Volvé a intentarlo</strong>, haciendo <b (click)="redirectLogin()">clic acá</b>
          </p>
          <p *ngIf="error.status === 'cannot-login'">Te esperamos pronto.</p>
          <p *ngIf="error.status === 'cannot-login'">
            <strong>Volvé al inicio</strong>, haciendo <b (click)="redirectLogin()">clic acá</b>
          </p>
        </ng-container>

        <ng-template #ospm_template>
          <div class="ospm-error">
            <h1>Detectamos que tus aportes <br /> son derivados a través de OSPM.</h1>

            <p>
              Es necesario que realices <strong>el traspaso a Nobis</strong> <br />
              (cód. <strong>904006</strong>) para evitar quedarte <strong> <br />
              sin cobertura a partir del 07/07.
              </strong>
            </p>

            <div class="buttons-container">        
              <p><a href="https://nobis.com.ar/traspasos-ospm/" target="_blank">MÁS INFORMACIÓN</a></p>
              <nobis-button (click)="redirectLogin()">ACEPTAR</nobis-button>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </section>
</ng-template>